import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { CommandItem } from "@tellescope/ui";
import { formatInitials, formatName } from "@tellescope/utils";
import { OutOfOfficeBadge } from "../outOfOffice";

type User = TellescopeModelFromName<"users">;

export interface UserOptionProps {
  user: User;
  onSelect: () => void;
  isOutOfOffice?: boolean;
}

export const UserOption = ({ user, onSelect, isOutOfOffice }: UserOptionProps) => (
  <CommandItem value={`user:${user.id}:${formatName(user)}`} onSelect={onSelect} className="flex items-center gap-2">
    <span className="flex-shrink-0 h-6 w-6 rounded-full bg-primary/20 text-primary text-xs flex items-center justify-center font-medium">
      {formatInitials(user)}
    </span>
    <span className="truncate">{formatName(user)}</span>
    {isOutOfOffice && <OutOfOfficeBadge />}
  </CommandItem>
);
